import * as React from "react";
import type { SVGProps } from "react";
const SvgRequestLog = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 23 26" {...props}>
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth={1.2}
      d="M3.287 7.273c0-1.573 0-2.36.486-2.782.487-.423 1.286-.311 2.884-.087 1.587.223 3.45.432 4.919.445 1.488.014 3.313-.185 4.871-.408 1.628-.233 2.442-.35 2.93.074.488.423.488 1.219.488 2.812v11.386c0 1.582 0 2.373-.487 2.796s-1.293.308-2.904.08c-1.576-.223-3.423-.428-4.898-.428s-3.322.205-4.898.428c-1.611.228-2.417.343-2.904-.08s-.487-1.214-.487-2.796z"
    />
    <path
      fill="#F5F5F5"
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth={1.2}
      d="M1 3.854c0-.664 0-.996.1-1.247a1.4 1.4 0 0 1 .909-.833c.259-.078.594-.049 1.263.01 2.26.197 5.75.461 8.304.474 2.622.012 6.063-.255 8.296-.46.668-.06 1.003-.091 1.26-.017a1.4 1.4 0 0 1 .922.842c.098.25.098.58.098 1.24 0 .658 0 .987-.098 1.236a1.4 1.4 0 0 1-.92.841c-.256.075-.589.046-1.253-.014-2.25-.2-5.724-.467-8.305-.467-2.577 0-6.046.266-8.296.467-.673.06-1.01.09-1.27.012a1.4 1.4 0 0 1-.91-.833C1 4.854 1 4.52 1 3.854Zm0 17.722c0-.664 0-.996.1-1.248a1.4 1.4 0 0 1 .909-.832c.259-.078.594-.049 1.263.01 2.26.196 5.75.46 8.304.473 2.622.013 6.063-.254 8.296-.459.668-.061 1.003-.092 1.26-.017a1.4 1.4 0 0 1 .922.842c.098.249.098.58.098 1.24 0 .658 0 .986-.098 1.235a1.4 1.4 0 0 1-.92.842c-.256.075-.589.045-1.253-.014-2.25-.2-5.724-.468-8.305-.468-2.577 0-6.046.267-8.296.467-.673.06-1.01.09-1.27.013a1.4 1.4 0 0 1-.91-.833c-.1-.252-.1-.585-.1-1.251Z"
    />
    <rect
      width={2.287}
      height={5.717}
      x={2.715}
      y={1}
      fill="#F5F5F5"
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth={1.2}
      rx={1.143}
    />
    <rect
      width={2.287}
      height={5.717}
      x={2.715}
      y={18.722}
      fill="#F5F5F5"
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth={1.2}
      rx={1.143}
    />
    <rect
      width={2.287}
      height={5.717}
      x={18.15}
      y={1}
      fill="#F5F5F5"
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth={1.2}
      rx={1.143}
    />
    <rect
      width={2.287}
      height={5.717}
      x={18.15}
      y={18.722}
      fill="#F5F5F5"
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth={1.2}
      rx={1.143}
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth={1.5}
      d="M6.953 9.432H16.1m-9.147 3.233h6.289m-6.289 3.233h4.002"
    />
  </svg>
);
export default SvgRequestLog;
